import { Tabs } from '@mantine/core';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  value: string;
};

export default function TabPanel({ children, value }: Props) {
  return <Tabs.Panel value={value}>{children}</Tabs.Panel>;
}
